"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _generateClassName = require("./generateClassName.utils");
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function generateClassName() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$component = _ref.component,
    component = _ref$component === void 0 ? '' : _ref$component,
    _ref$componentKeySpli = _ref.componentKeySplit,
    componentKeySplit = _ref$componentKeySpli === void 0 ? true : _ref$componentKeySpli,
    _ref$child = _ref.child,
    child = _ref$child === void 0 ? '' : _ref$child,
    _ref$childKeySplit = _ref.childKeySplit,
    childKeySplit = _ref$childKeySplit === void 0 ? true : _ref$childKeySplit,
    modifiers = _ref.modifiers;
  if (!component && !child && (!modifiers || modifiers)) {
    return {};
  }
  var _handleInitialClassNa = (0, _generateClassName.handleInitialClassNames)({
      component: component,
      componentKeySplit: componentKeySplit
    }),
    initialKeyName = _handleInitialClassNa.initialKeyName,
    initialComponentName = _handleInitialClassNa.initialComponentName;
  var _handleComponentAndCh = (0, _generateClassName.handleComponentAndChildClassNames)({
      child: child,
      component: component,
      initialComponentName: initialComponentName,
      initialKeyName: initialKeyName,
      childKeySplit: childKeySplit
    }),
    keyName = _handleComponentAndCh.keyName,
    generatedClassName = _handleComponentAndCh.generatedClassName;
  if ((component || child) && modifiers && Array.isArray(modifiers)) {
    return (0, _generateClassName.handleModifierClassNames)({
      modifiers: modifiers,
      keyName: keyName,
      generatedClassName: generatedClassName
    });
  }
  return _defineProperty({}, keyName, generatedClassName);
}
var _default = exports["default"] = generateClassName;